export function capitalizeFirstLetter(string) {
    let splitString = string.split(" ");
    const capitalizedWords = [];
    for (var i = 0; i < splitString.length; i++) {
        capitalizedWords.push(splitString[i].charAt(0).toUpperCase() + splitString[i].slice(1))
        string = capitalizedWords.join(" ");
    }
    return string;
}